var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouteMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-route-marker"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "route-marker",
    clipPath: "url(#clip-route-marker)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23546",
    "data-name": "Group 23546",
    transform: "translate(7861.705 -2920.355) rotate(-1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1802",
    "data-name": "Ellipse 1802",
    cx: 6.418,
    cy: 7.131,
    rx: 6.418,
    ry: 7.131,
    transform: "translate(-7902.458 2789.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29423",
    "data-name": "Path 29423",
    d: "M12.455,18.09a5.3,5.3,0,0,0,5.3-5.3,5.458,5.458,0,0,0-5.3-5.493,5.3,5.3,0,0,0-5.3,5.3A5.591,5.591,0,0,0,12.455,18.09Zm-8.9-14.4A12.591,12.591,0,0,1,21.358,21.5l-8.9,8.9-8.9-8.9A12.934,12.934,0,0,1,3.552,3.694Z",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, -7907.744, 2783.352)",
    fill: "#fe5969",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteMarker);
export default __webpack_public_path__ + "static/media/route-marker.0adba7ae3f1691dfe33d4546f9152dc9.svg";
export { ForwardRef as ReactComponent };